import { useState, useEffect, useRef } from "react";
import { HiOutlineGlobeAlt } from 'react-icons/hi';
import { FiHome } from 'react-icons/fi';
import { IoAirplaneOutline } from 'react-icons/io5';
import { IoLocationSharp } from 'react-icons/io5';
import { Star, MapPin, Phone, Shield, Clock } from 'lucide-react';
import bg from "../assets/image.png";
import { MdOutlineFlight, MdHome, MdOutlineExplore } from 'react-icons/md';

// import hero1 from "../assets/image.png"
// import hero2 from "../assets/image.png"

import urbania from "../assets/image.png";
import crysta from "../assets/image.png";
import tempo from "../assets/image.png";
import bus from "../assets/image.png";
// import ertiga from "../assets/image.png";
import Dezire from "../assets/image.png";
// import city from "../assets/image.png";
import Ciaz from "../assets/image.png";
import etios from "../assets/image.png";
import mb1 from "../assets/image.png";
import mb2 from "../assets/image.png";
import kiaCarens from "../assets/image.png";
import InnovaBase from "../assets/image.png"
import hycross from "../assets/image.png"

import buss from "../assets/image.png"


// import sedan from "../assets/image.png"

// import AirportBookingForm from '../components/BookingForms/AirportBookingForm';
// import OutstationBookingForm from '../components/BookingForms/OutstationBookingForm';
// import LocalBookingForm from '../components/BookingForms/LocalBookingForm';
import { bookingService } from '../services/Bookingservice';

import taxiImage from "../assets/honda-city-hatchback-2024-white-pearl.png";
import { useNavigate } from "react-router-dom";
import BookingFormPopup from '../BookingForm/Bookingform';
// import fortuner from "../assets/fortunes.avif"

const HERO_BACKGROUND = bg;
const MOBILE_BG_IMAGES = [mb1];

const sedan ="https://static.caronphone.com/public/brands/21/493/2518/2518_1731400393.webp"
const city=    "https://c4.wallpaperflare.com/wallpaper/614/644/854/2019-corolla-gli-toyota-wallpaper-thumb.jpg"
const ertiga ="https://imgd.aeplcdn.com/664x374/n/c6es93a_1572125.jpg?q=80"

const VEHICLES = {
  outstation: [
    { id:2, image:"sedan", name:"Swift Dzire", models:"Swift Dzire", type:"Comfort", seaters:"4", bags:2, price:"₹14/km", per:null, tag:"Popular", badge:"popular", rating:4.7, features:["Spacious Boot","Business Travel","Smooth Ride"] },
    { id:10, image:"premiumSedan", name:"Etios", models:" Etios", type:"Comfort", seaters:"4", bags:2, price:"₹14/km", per:null, tag:"Popular", badge:"popular", rating:4.7, features:["Spacious Boot","Business Travel","Smooth Ride"] },
    // { id:4, image:"ertiga", name:"Ertiga (6+1 seats)", models:"Ertiga, Innova", type:"Family", seaters:"6", bags:4, price:"₹18/km", per:null, tag:"Best Value", badge:"value", rating:4.6, features:["Group Travel","Extra Luggage","3 Rows"] },
    // { id:5, image:"crysta", name:"Innova Crysta (7+1 seats)", models:"Toyota Innova", type:"Premium SUV", seaters:"7", bags:5, price:"₹19/km", per:null, tag:null, badge:null, rating:4.9, features:["Luxury Interior","Captain Seats","Premium AC"] },
    // { id:6, image:"hycross", name:"Innova Hybrid (7+1 seats)", models:"Innova Hycross", type:"Luxury", seaters:"7", bags:5, price:"₹23/km", per:null, tag:"Top Pick", badge:"top", rating:5.0, features:["Hybrid Engine","Panoramic Roof","ADAS Safety"] },
    // { id:7, image:"fortuner", name:"Fortuner (7+1 seats)", models:"Fortuner", type:"Luxury", seaters:"7", bags:5, price:"₹60/km", per:null, tag:"Top Pick", badge:"top", rating:5.0, features:["Hybrid Engine","Panoramic Roof","ADAS Safety"] },
    // { id:8, image:"tempo", name:"Tempo Traveller", models:"9 / 12 Seater", type:"Group", seaters:12, bags:8, price:"₹24/km", per:null, tag:null, badge:null, rating:4.5, features:["Pushback Seats","Group Trips","Large Luggage"] },
    // { id:9, image:"Urbania", name:"Urbania", models:"9–16 Seater", type:"Large Group", seaters:"16", bags:20, price:"₹43/km", per:null, tag:null, badge:null, rating:4.4, features:["Restroom","Luggage Bay","Events & Tours"] },
    // { id:11, image:"buss", name:"Bus", models:"21-50 Seater", type:"Large Group", seaters:"50", bags:20, price:"₹35/km", per:null, tag:null, badge:null, rating:4.4, features:["Restroom","Luggage Bay","Events & Tours"] },

  ],
  airport: [
    { id:10, image:"sedan", name:"Swift Dzire", models:"Swift Dzire, Etios", type:"Comfort", seaters:"4+1", bags:2, price:"₹900",Hourprice:"3 Hrs/50 kms", per:null, tag:"Most Booked", badge:"popular", rating:4.8, features:["Flight Tracking","Meet & Greet","Waiting Included"] },
    { id:11, image:"premiumSedan", name:"Etios", models:"Swift Dzire, Etios", type:"Comfort", seaters:"4+1", bags:2, price:"₹700",Hourprice:"2 Hrs/20 kms", per:null, tag:"Most Booked", badge:"popular", rating:4.8, features:["Flight Tracking","Meet & Greet","Waiting Included"] },
    // { id:12, image:"ertiga", name:"Ertiga (6+1 seats)", models:"Innova, Ertiga", type:"Family", seaters:"6+1", bags:4, price:"₹1,599",Hourprice:"3 Hrs/50 kms", per:null, tag:null, badge:null, rating:4.7, features:["Extra Luggage","Family Comfort","Premium Service"] },
    // { id:18, image:"kiaCarens", name:"Kia Carens (6+1 seats)", models:"Kia Carens", type:"Family", seaters:"6+1", bags:5, price:"₹1,699", per:null, tag:null, badge:null, rating:4.7, features:["Extra Luggage","Family Comfort","Premium Service"] },
    // { id:13, image:"innova", name:"Innova (7+1 seats)", models:"Innova, Ertiga", type:"Family", seaters:7, bags:5, price:"₹1,799", per:null, tag:null, badge:null, rating:4.7, features:["Extra Luggage","Family Comfort","Premium Service"] },
    // { id:14, image:"crysta", name:"Innova Crysta (7+1 seats)", models:"Toyota Innova Crysta", type:"Premium Family", seaters:7, bags:5, price:"₹1,999", per:null, tag:null, badge:null, rating:4.8, features:["Luxury Interior","Captain Seats","Premium AC"] },
    // { id:15, image:"hycross", name:"Innova Hycross (7+1 seats)", models:"Toyota Innova Crysta", type:"Premium Family", seaters:7, bags:5, price:"₹2,299", per:null, tag:null, badge:null, rating:4.8, features:["Luxury Interior","Captain Seats","Premium AC"] },
    // { id:16, image:"fortuner", name:"Fortuner (7+1 seats)", models:"Toyota Fortuner", type:"Premium SUV", seaters:7, bags:5, price:"₹4,000", per:null, tag:null, badge:null, rating:4.8, features:["Luxury Interior","Captain Seats","Premium AC"] },
    // { id:17, image:"tempo", name:"Tempo Traveller", models:"12 Seater", type:"Group", seaters:12, bags:8, price:"₹4,500", per:null, tag:null, badge:null, rating:4.7, features:["Extra Luggage","Group Travel","Premium Service"] },
  ],
  local: [
    { id:13, image:"sedan", name:"Swift Dzire", models:"Swift Dzire, Etios", type:"Comfort 4hr", seaters:4, bags:2, price:"₹1,000", per:"/4 hrs (40 kms)", tag:"Popular", badge:"popular", rating:4.6, features:["40 kms included","Business Meetings","Smooth Ride"] },
    { id:21, image:"premiumSedan", name:"Etios (4+1 seats)", models:" Etios", type:"Comfort 4hr", seaters:4, bags:2, price:"₹2,000", per:"/4 hrs (40 kms)", tag:"Popular", badge:"popular", rating:4.6, features:["40 kms included","Business Meetings","Smooth Ride"] },
    // { id:16, image:"sedan", name:"Sedan (4+1 seats)", models:"Swift Dzire, Etios, Amaze", type:"Comfort 8hr", seaters:4, bags:3, price:"₹2,000", per:"/8 hrs (80 kms)", tag:"Popular", badge:"popular", rating:4.7, features:["80 kms included","Full Day Comfort","Toll & Parking Extra"] },
    // { id:17, image:"ertiga", name:"Ertiga (6+1 seats)", models:"Maruti Ertiga", type:"Family 8hr", seaters:7, bags:4, price:"₹1,600", per:"/8 hrs (80 kms)", tag:"Best Value", badge:"value", rating:4.5, features:["80 kms included","7 Seater","Toll & Parking Extra"] },
    // { id:18, image:"fortuner", name:"Fortuner & Kia Carnival (7+1 seats)", models:"Toyota Innova", type:"Premium 8hr", seaters:7, bags:5, price:"₹3,500", per:"/8 hrs (80 kms)", tag:"Popular", badge:"popular", rating:4.8, features:["80 kms included","7 Seater","Spacious Interior","Toll & Parking Extra"] },
    // { id:19, image:"crysta", name:"Innova Crysta (7+1 seats)", models:"Toyota Innova Crysta", type:"Luxury 8hr", seaters:7, bags:5, price:"₹4,000", per:"/8 hrs (80 kms)", tag:"Premium", badge:"top", rating:4.9, features:["80 kms included","7 Seater","Luxury Interior","Toll & Parking Extra"] },
    // { id:14, image:"hycross", name:"Innova Hycross Hybrid(7+1 seats)", models:"Xylo, Innova", type:"Family 4hr", seaters:7, bags:4, price:"₹1,800", per:"/4 hrs (40 kms)", tag:null, badge:null, rating:4.5, features:["40 kms included","Group Outings","Family Trips"] },
    // { id:20, image:"tempo", name:"Tempo Traveller", models:"12-13 Seater", type:"Group 8hr", seaters:13, bags:8, price:"₹5,000", per:"/8 hrs (80 kms)", tag:"Group Special", badge:"value", rating:4.6, features:["80 kms included","13 Seater","Pushback Seats","Toll & Parking Extra"] },
    // { id:22, image:"Urbania", name:"Urbania", models:"12-13 Seater", type:"Group 8hr", seaters:13, bags:8, price:"₹8,000", per:"/8 hrs (80 kms)", tag:"Group Special", badge:"value", rating:4.6, features:["80 kms included","13 Seater","Pushback Seats","Toll & Parking Extra"] },
    // { id:21, image:"buss", name:"Bus", models:"12-13 Seater", type:"Group 8hr", seaters:13, bags:8, price:"₹5,000", per:"/8 hrs (80 kms)", tag:"Group Special", badge:"value", rating:4.6, features:["80 kms included","13 Seater","Pushback Seats","Toll & Parking Extra"] },



  ]
};

const TRIPS = [
  { id:"airport", icon: IoAirplaneOutline, emojiIcon: MdOutlineFlight, label:"Airport", sub:"Transfer", stats:["3 Vehicles","₹799"], color:"#1A73E8", icon2: <IoAirplaneOutline size={18} />, desc:"Flight pickups & drops" },
  { id:"outstation", icon: HiOutlineGlobeAlt, emojiIcon: MdOutlineExplore, label:"Outstation", sub:"Inter-City", stats:["8 Vehicles","₹8/km"], color:"#FF6B35", icon2: <HiOutlineGlobeAlt size={18} />, desc:"Long distance travel" },
  { id:"local", icon: FiHome, emojiIcon: MdHome, label:"Local", sub:"Hourly", stats:["6 Packages","₹500/4hrs"], color:"#0B8A4D", icon2: <FiHome size={18} />, desc:"City errands & tours" },
];


const hero1="https://upload.wikimedia.org/wikipedia/commons/d/db/Chennai_Central_D.jpg"
const hero2 = "https://wallpapers.com/images/hd/chennai-marina-beach-pwxc147k0x3ah8bi.jpg"


const backgroundImage = "https://upload.wikimedia.org/wikipedia/commons/d/db/Chennai_Central_D.jpg";

const BADGES = {
  popular: { bg:"#FFF3CD", color:"#92400E", label:"🔥 Popular" },
  value:   { bg:"#D1FAE5", color:"#065F46", label:"💎 Best Value" },
  top:     { bg:"#FEE2E2", color:"#991B1B", label:"⭐ Top Pick" },
};

const Y = "#ff8c00";
const G = "#28aa96";
const YD = "#B8860B";
const YL = "#FFF9E6";
const font = "'Nunito', sans-serif";
const fontD = "'Barlow', sans-serif";

const getVehicleImage = (vehicle) => {
  const map = { hatchback:Dezire, sedan:sedan, premiumSedan:city,kiaCarens:kiaCarens, ertiga:ertiga,innova:InnovaBase, crysta:crysta,hycross:hycross, tempo:tempo, Urbania:bus,buss:buss, default:crysta };
  return map[vehicle.image] || map.default;
};

// fortuner:fortuner,

/* ── TRIP TAB ── */
function MobileTripTab({ trip, selected, onClick }) {
  const on = selected === trip.id;
  const Icon = trip.icon;

  return (
    <button onClick={onClick} style={{
      flex:1, border:"none", cursor:"pointer",
      background: on ? Y : "#F8F8F8",
      borderRadius:18, padding:"14px 6px 12px",
      transition:"all 0.25s cubic-bezier(0.34,1.56,0.64,1)",
      boxShadow: on ? `0 8px 24px rgba(255,214,0,0.5), 0 2px 8px rgba(0,0,0,0.08)` : "0 1px 3px rgba(0,0,0,0.05)",
      transform: on ? "translateY(-4px) scale(1.04)" : "scale(1)",
      outline:"none",
      position:"relative",
      overflow:"hidden",
    }}>
      {on && (
        <div style={{
          position:"absolute", top:0, left:0, right:0, height:3,
          background:"linear-gradient(90deg, #1e7467, #28aa96)",
          borderRadius:"3px 3px 0 0",
        }} />
      )}
      <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:5 }}>
        <div style={{
          width:44, height:44, borderRadius:15,
          background: on ? "rgba(0,0,0,0.1)" : "#fff",
          display:"flex", alignItems:"center", justifyContent:"center",
          boxShadow: on ? "none" : "0 2px 8px rgba(0,0,0,0.08)",
          border: on ? "none" : "1.5px solid #F0F0F0",
        }}>
          <Icon size={20} color={on ? "#1A1A1A" : trip.color} />
        </div>
        <span style={{ fontSize:11, fontWeight:900, color: on ? "#1A1A1A" : "#444", letterSpacing:0.2 }}>
          {trip.label}
        </span>
        <span style={{
          fontSize:8.5, fontWeight:800,
          color: on ? "rgba(0,0,0,0.55)" : "#BBB",
          background: on ? "rgba(0,0,0,0.07)" : "#EFEFEF",
          padding:"2px 8px", borderRadius:20,
          letterSpacing:0.3,
        }}>
          {trip.sub}
        </span>
      </div>
    </button>
  );
}

/* ── VEHICLE CARD - 100% WORKING WITH PROPER FORMATS ── */
function MobileVCard({ v, onBook, index, tripType }) {
  const [pressed, setPressed] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('8hr'); // Default to '8hr' for premium vehicles
  const bc = v.badge ? BADGES[v.badge] : null;
  const imageUrl = getVehicleImage(v);

  // Get vehicle-specific extra charges for local packages
  const getExtraCharges = (hours) => {
    const vehicleName = v.name?.toLowerCase() || '';
    
    if (vehicleName.includes('etios')) return { extraKm: '15.00', extraHr: '150' };
        if (vehicleName.includes('swift dzire')) return { extraKm: '13.00', extraHr: '175' };
    if (vehicleName.includes('ciaz')) return { extraKm: '16.00', extraHr: '160' };
    if (vehicleName.includes('ertiga')) return { extraKm: '20.00', extraHr: '200' };
    if (vehicleName.includes('kia') || vehicleName.includes('carens')) return { extraKm: '20.00', extraHr: '200' };
    if (vehicleName.includes('innova') && !vehicleName.includes('crysta') && !vehicleName.includes('hycross')) return { extraKm: '20.00', extraHr: '200' };
    if (vehicleName.includes('innova crysta')) return { extraKm: '25.00', extraHr: '250' };
    if (vehicleName.includes('innova hycross')) return { extraKm: '30.00', extraHr: '300' };
    if (vehicleName.includes('fortuner')) return { extraKm: '25.00', extraHr: '250' };
    if (vehicleName.includes('tempo')) return { extraKm: '30.00', extraHr: '300' };
    if (vehicleName.includes('carnival')) return { extraKm: '25.00', extraHr: '250' };
    if (vehicleName.includes('mini bus') || vehicleName.includes('bus')) return { extraKm: '50.00', extraHr: '500' };
    
    // Default based on seaters
    if (v.seaters <= 4) return { extraKm: '15.00', extraHr: '150' };
    if (v.seaters <= 6) return { extraKm: '18.00', extraHr: '180' };
    if (v.seaters <= 7) return { extraKm: '20.00', extraHr: '200' };
    if (v.seaters <= 12) return { extraKm: '25.00', extraHr: '250' };
    return { extraKm: '30.00', extraHr: '300' };
  };

  // Check if vehicle should show only 8hr package
  const showOnly8hr = () => {
    const vehicleName = v.name?.toLowerCase() || '';
    return vehicleName.includes('tempo') || 
           vehicleName.includes('bus') || 

           vehicleName.includes('fortuner') || 
           vehicleName.includes('carnival') || 
           vehicleName.includes('hycross') || 
           vehicleName.includes('crysta') ||
           vehicleName.includes('innova crysta') ||
           vehicleName.includes('innova hycross');
  };

  // Get display name for vehicle
  const getDisplayName = () => {
    const name = v.name?.toUpperCase() || '';
    if (name.includes('SEDAN')) return 'SEDAN';
    if (name.includes('ETIOS')) return 'TOYOTA ETIOS';
    if (name.includes('CIAZ')) return 'MARUTI CIAZ';
    if (name.includes('ERTIGA')) return 'MARUTI ERTIGA';
    if (name.includes('CARENS')) return 'KIA CARENS';
    if (name.includes('INNOVA') && name.includes('CRYSTA')) return 'INNOVA CRYSTA';
    if (name.includes('HYCROSS')) return 'INNOVA HYCROSS HYBRID';
    if (name.includes('FORTUNER')) return 'FORTUNER & KIA CARNIVAL';
    if (name.includes('TEMPO')) return 'TEMPO TRAVELLER';
    if (name.includes('BUS') ) return 'BUS';
    if(name.includes('URBANIA')) return 'URBANIA';
    return v.name?.toUpperCase() || '';
  };

  // Get package details for local trips
  const getPackageDetails = () => {
    const vehicleName = v.name?.toLowerCase() || '';
    
    // Sedan packages (for Swift Dzire, Etios, Ciaz, etc.)
    if (vehicleName.includes('SEDAN') || vehicleName.includes('etios') || vehicleName.includes('ciaz')) {
      return {
        isSedan: true,
        showOnly8hr: false,
        packages: {
          '4hr': {
            hours: '4 Hrs',
            kms: '40 Kms',
            price: '₹1,000/-',
            extraKm: '13.00',
            extraHr: '175'
          },
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹2,000/-',
            extraKm: '13.00',
            extraHr: '175'
          }
        }
      };
    }

    if (vehicleName.includes('innova') && !vehicleName.includes('crysta') && !vehicleName.includes('hycross') && !vehicleName.includes('fortuner')) {
      return {
        isSedan: true,
        showOnly8hr: false,
        packages: {
          '4hr': {
            hours: '4 Hrs',
            kms: '40 Kms',
            price: '₹1,300/-',
            extraKm: '15.00',
            extraHr: '160'
          },
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹3,800/-',
            extraKm: '24.00',
            extraHr: '250'
          }
        }
      };
    }
    
    // Ertiga packages
    if (vehicleName.includes('ertiga')) {
      return {
        isSedan: false,
        showOnly8hr: false,
        packages: {
          '4hr': {
            hours: '4 Hrs',
            kms: '40 Kms',
            price: '₹2,100/-',
            extraKm: '17.00',
            extraHr: '170'
          },
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹2,900/-',
            extraKm: '17.00',
            extraHr: '170'
          }
        }
      };
    }
    
    // Fortuner & Kia Carnival packages (8hr only)
    if (vehicleName.includes('fortuner') || vehicleName.includes('carnival')) {
      return {
        isSedan: false,
        showOnly8hr: true,
        packages: {
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹7,000/-',
            extraKm: '60.00',
            extraHr: '600'
          }
        }
      };
    }
    
    // Innova Crysta packages (8hr only)
    if (vehicleName.includes('innova crysta')) {
      return {
        isSedan: false,
        showOnly8hr: true,
        packages: {
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹3,500/-',
            extraKm: '22.00',
            extraHr: '220'
          }
        }
      };
    }
    
    // Innova Hycross packages (8hr only)
    if (vehicleName.includes('innova hycross') || vehicleName.includes('hycross')) {
      return {
        isSedan: false,
        showOnly8hr: true,
        packages: {
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹3,800/-',
            extraKm: '24.00',
            extraHr: '250'
          }
        }
      };
    }

    // Tempo Traveller packages (8hr only)
    if (vehicleName.includes('tempo')) {
      return {
        isSedan: false,
        showOnly8hr: true,
        packages: {
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹5,500/-',
            extraKm: '30.00',
            extraHr: '400'
          }
        }
      };
    } 

     if (vehicleName.includes('bus')) {
      return {
        isSedan: false,
        showOnly8hr: true,
        packages: {
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹10,000/-',
            extraKm: '50.00',
            extraHr: '600'
          }
        }
      };
    } 


    
     if (vehicleName.includes('urbania')) {
      return {
        isSedan: false,
        showOnly8hr: true,
        packages: {
          '8hr': {
            hours: '8 Hrs',
            kms: '80 Kms',
            price: '₹8,000/-',
            extraKm: '45.00',
            extraHr: '500'
          }
        }
      };
    } 

    // Default fallback
    const charges = getExtraCharges();
    const only8hr = showOnly8hr();
    return {
      isSedan: false,
      showOnly8hr: only8hr,
      packages: only8hr ? {
        '8hr': {
          hours: '8 Hrs',
          kms: '80 Kms',
          price: v.price8hr || '₹3,500/-',
          extraKm: charges.extraKm,
          extraHr: charges.extraHr
        }
      } : {
        '4hr': {
          hours: '4 Hrs',
          kms: '40 Kms',
          price: v.price || '₹1,000/-',
          extraKm: charges.extraKm,
          extraHr: charges.extraHr
        },
        '8hr': {
          hours: '8 Hrs',
          kms: '80 Kms',
          price: v.price8hr || '₹2,000/-',
          extraKm: charges.extraKm,
          extraHr: charges.extraHr
        }
      }
    };
  };

  const packageDetails = tripType === 'local' ? getPackageDetails() : null;
  const currentPackage = packageDetails?.packages[selectedPackage];

  // Render based on trip type
  return (
    <div
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setPressed(false)}
      style={{
        background: "#fff",
        borderRadius: 20,
        overflow: "hidden",
        marginBottom: 14,
        boxShadow: pressed ? "0 6px 12px rgba(0,0,0,0.1)" : "0 8px 20px rgba(0,0,0,0.08)",
        border: pressed ? `1.5px solid ${Y}` : "1.5px solid #F0F0F0",
        transform: pressed ? "scale(0.99)" : "scale(1)",
        transition: "all 0.2s ease",
        animation: `cardIn 0.4s ${index * 0.06}s ease both`,
      }}
    >
      {/* Image Section */}
      <div style={{
        position: "relative",
        height: "150px",
        background: "#f8f8f8",
        overflow: "hidden",
      }}>
        {!imageLoaded && (
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
          }} />
        )}
        
        <img 
          src={imageUrl} 
          alt={v.name}
          onLoad={() => setImageLoaded(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "center 60%",
            transform: "scale(1.1)",
            transition: "transform 0.5s ease, opacity 0.3s ease",
            opacity: imageLoaded ? 1 : 0,
          }}
        />

        <div style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "30%",
          background: "linear-gradient(to top, rgba(255,255,255,0.95), transparent)",
        }} />

        {bc && (
          <div style={{
            position: "absolute",
            top: 8,
            left: 8,
            background: bc.bg,
            borderRadius: 20,
            padding: "4px 10px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            zIndex: 2,
          }}>
            <span style={{ fontSize: 10, fontWeight: 800, color: bc.color }}>
              {bc.label}
            </span>
          </div>
        )}

        <div style={{
          position: "absolute",
          top: 8,
          right: 8,
          background: "rgba(255,255,255,0.95)",
          borderRadius: 20,
          padding: "4px 10px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          backdropFilter: "blur(4px)",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}>
          <MapPin size={10} color={YD} />
          <span style={{ fontSize: 9, fontWeight: 700, color: "#1A1A1A" }}>
            BLR
          </span>
        </div>
        
        {/* Premium Badge for 8hr-only vehicles */}
        {packageDetails?.showOnly8hr && (
          <div style={{
            position: "absolute",
            bottom: 8,
            left: 8,
            background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
            borderRadius: 20,
            padding: "4px 10px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            zIndex: 2,
          }}>
            <span style={{ fontSize: 9, fontWeight: 800, color: "#1A1A1A" }}>
              ⭐ PREMIUM • 8HR ONLY
            </span>
          </div>
        )}
      </div>

      {/* Content Section */}
      <div style={{ padding: "12px" }}>
        
        {/* LOCAL FORMAT WITH PACKAGE TOGGLE */}
        {tripType === 'local' && packageDetails && (
          <>
            <h3 style={{
              fontSize: 18,
              fontWeight: 900,
              color: "#1A1A1A",
              margin: "0 0 8px 0",
              lineHeight: 1.2,
            }}>
              {getDisplayName()}
            </h3>
            
            {/* Package Toggle Buttons - Only show if both packages available */}
            {!packageDetails.showOnly8hr && (
              <div style={{
                display: "flex",
                gap: 8,
                marginBottom: 12,
                background: "#F0F0F0",
                padding: 4,
                borderRadius: 12,
              }}>
                <button
                  onClick={() => setSelectedPackage('4hr')}
                  style={{
                    flex: 1,
                    border: "none",
                    background: selectedPackage === '4hr' ? Y : "transparent",
                    color: selectedPackage === '4hr' ? "#1A1A1A" : "#666",
                    padding: "8px 4px",
                    borderRadius: 10,
                    fontSize: 11,
                    fontWeight: 800,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  4 Hrs / 40 Kms
                </button>
                <button
                  onClick={() => setSelectedPackage('8hr')}
                  style={{
                    flex: 1,
                    border: "none",
                    background: selectedPackage === '8hr' ? Y : "transparent",
                    color: selectedPackage === '8hr' ? "#1A1A1A" : "#666",
                    padding: "8px 4px",
                    borderRadius: 10,
                    fontSize: 11,
                    fontWeight: 800,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  8 Hrs / 80 Kms
                </button>
              </div>
            )}

            {/* Show single package indicator for 8hr-only vehicles */}
            {packageDetails.showOnly8hr && (
              <div style={{
                display: "flex",
                gap: 8,
                marginBottom: 12,
              }}>
                <div style={{
                  flex: 1,
                  background: Y,
                  color: "#1A1A1A",
                  padding: "8px 4px",
                  borderRadius: 10,
                  fontSize: 11,
                  fontWeight: 800,
                  textAlign: "center",
                }}>
                  8 Hrs / 80 Kms Package
                </div>
              </div>
            )}
            
            <div style={{
              background: "#F8F8F8",
              borderRadius: 12,
              padding: "12px",
              marginBottom: 10,
              border: "1px solid #EEEEEE",
            }}>
              <div style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#1A1A1A",
                marginBottom: 8,
              }}>
                Package {currentPackage.hours} {currentPackage.kms}
              </div>
              
              <div style={{
                fontSize: 13,
                color: "#1A1A1A",
                marginBottom: 8,
              }}>
                Extra KM ₹{currentPackage.extraKm} • Extra HR ₹{currentPackage.extraHr}
              </div>
              
              <div style={{
                fontSize: 13,
                color: "#1A1A1A",
                marginBottom: 10,
              }}>
                {v.seaters}+1 people • {v.bags} luggage
              </div>

              <div style={{
                fontSize: 13,
                color: "#1A1A1A",
                marginBottom: 8,
              }}>
                Toll & Parking Extra
              </div>
              
              <div style={{
                fontSize: 18,
                fontWeight: 900,
                color: "#1A1A1A",
                borderTop: "1px dashed #DDD",
                paddingTop: 8,
              }}>
                {currentPackage.price}
              </div>
            </div>

            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 4,
              marginBottom: 10,
            }}>
              {v.features?.map((f, fi) => (
                <span key={fi} style={{
                  fontSize: 9,
                  fontWeight: 600,
                  color: YD,
                  background: YL,
                  padding: "3px 8px",
                  borderRadius: 20,
                  border: `1px solid #FFE082`,
                }}>
                  {f}
                </span>
              ))}
            </div>
          </>
        )}
        
        {/* AIRPORT FORMAT */}
        {tripType === 'airport' && (
          <>
            <div style={{ marginBottom: 8 }}>
              <h3 style={{
                fontSize: 18,
                fontWeight: 900,
                color: "#1A1A1A",
                margin: 0,
                lineHeight: 1.2,
              }}>
                {v.name}
              </h3>
              <p style={{
                fontSize: 11,
                color: "#666",
                margin: "2px 0 0",
                fontWeight: 500,
              }}>
                {v.models}
              </p>
 {v.Hourprice && (
        <div style={{
          display: "inline-block",
          background: "#28aa96", // Your green color
          color: "white",
          fontSize: 11,
          fontWeight: 800,
          padding: "4px 12px",
          borderRadius: 20,
          marginTop: 8,
          boxShadow: "0 2px 8px rgba(40,170,150,0.3)",
          border: "1px solid rgba(255,255,255,0.2)"
        }}>
          ⏱️ {v.Hourprice}
        </div>
      )}
              
            </div>

            <div style={{
              background: "#F8F8F8",
              borderRadius: 12,
              padding: "12px",
              marginBottom: 10,
              border: "1px solid #EEEEEE",
            }}>


               
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 8,
                paddingBottom: 8,
                borderBottom: "1px dashed #DDD",
              }}>
                <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Base </span>
                <span style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>{v.price} </span>
              </div>
              
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 8,
                paddingBottom: 8,
                borderBottom: "1px dashed #DDD",
              }}>
                <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Capacity</span>
                <span style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>{v.seaters} seats • {v.bags} bags</span>
              </div>
              
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 8,
                paddingBottom: 8,
                borderBottom: "1px dashed #DDD",
              }}>
                <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Toll Charges</span>
                <span style={{ fontSize: 14, fontWeight: 800, color: "#E5182E" }}>Extra</span>
              </div>

              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
                <span style={{ fontSize: 18, fontWeight: 900, color: "#1A1A1A" }}>{v.price}</span>
                {v.rating && (
                  <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Star size={14} color={Y} fill={Y} />
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#1A1A1A" }}>{v.rating}</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 4,
              marginBottom: 10,
            }}>
              {v.features?.map((f, fi) => (
                <span key={fi} style={{
                  fontSize: 9,
                  fontWeight: 600,
                  color: YD,
                  background: YL,
                  padding: "3px 8px",
                  borderRadius: 20,
                  border: `1px solid #FFE082`,
                }}>
                  {f}
                </span>
              ))}
            </div>
          </>
        )}
        
        {/* OUTSTATION FORMAT */}
        {tripType === 'outstation' && (
          <>
            <div style={{ marginBottom: 8 }}>
              <h3 style={{
                fontSize: 18,
                fontWeight: 900,
                color: "#1A1A1A",
                margin: 0,
                lineHeight: 1.2,
              }}>
                {v.name}
              </h3>
              <p style={{
                fontSize: 11,
                color: "#666",
                margin: "2px 0 0",
                fontWeight: 500,
              }}>
                {v.models}
              </p>
            </div>

            <div style={{
              background: "#F8F8F8",
              borderRadius: 12,
              padding: "12px",
              marginBottom: 10,
              border: "1px solid #EEEEEE",
            }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 8,
                paddingBottom: 8,
                borderBottom: "1px dashed #DDD",
              }}>
                <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Min/day</span>
                <span style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>250 km</span>
              </div>
              
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 8,
                paddingBottom: 8,
                borderBottom: "1px dashed #DDD",
              }}>
                <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Driver Bata</span>
                <span style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>₹500/day</span>
              </div>
              
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 8,
                paddingBottom: 8,
                borderBottom: "1px dashed #DDD",
              }}>
                <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Capacity</span>
                <span style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>{v.seaters}+1 • {v.bags} bags</span>
              </div>
              
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
                <span style={{ fontSize: 13, color: "#666", fontWeight: 500 }}>Toll</span>
                <span style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>Extra</span>
              </div>
            </div>

            <div style={{
              fontSize: 18,
              fontWeight: 900,
              color: "#1A1A1A",
              textAlign: 'left',
              marginBottom: 10,
            }}>
              {v.price}
            </div>
          </>
        )}

        {/* Action Buttons - Same for all */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 6,
          marginTop: 4,
        }}>
          <button
            onClick={(e) => { e.stopPropagation(); onBook({...v, selectedPackage, packageDetails: currentPackage}); }}
            style={{
              background: Y,
              border: "none",
              color: "#1A1A1A",
              padding: "8px 0",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 800,
              cursor: "pointer",
            }}
          >
            Book Now
          </button>

          {/* <button
            onClick={(e) => { e.stopPropagation(); window.location.href = "tel:+919150410309"; }}
            style={{
              background: "#1A1A1A",
              border: "none",
              color: "#fff",
              padding: "8px 0",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 800,
              cursor: "pointer",
            }}
          >
            Call
          </button> */}

          <button
            onClick={(e) => { e.stopPropagation(); window.open("https://wa.me/919150410309", "_blank"); }}
            style={{
              background: "#25D366",
              border: "none",
              color: "#fff",
              padding: "8px 0",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 800,
              cursor: "pointer",
            }}
          >
            WhatsApp Booking
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─── DESKTOP VCard ─── */
function VCard({ v, onBook }) {
  const [h,setH]=useState(false);
  const bc=v.badge?BADGES[v.badge]:null;
  const imageUrl = getVehicleImage(v);
  return (
    <div onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{ background:h?"#161616":"#111", border:`1.5px solid ${h?Y:"#1e1e1e"}`, borderRadius:14, overflow:"hidden", cursor:"pointer", transition:"all .3s ease", transform:h?"translateY(-4px)":"translateY(0)", boxShadow:h?`0 20px 40px rgba(255,214,0,.15)`:"0 4px 12px rgba(0,0,0,.5)", display:"flex", flexDirection:"column", fontFamily:fontD, background:"rgba(17,17,17,0.95)" }}>
      <div style={{ position:"relative", height:130, overflow:"hidden" }}>
        <img src={imageUrl} alt={v.name} style={{ width:"100%", height:"100%", objectFit:"cover", transition:"transform .5s ease", transform:h?"scale(1.1)":"scale(1)" }} />
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(180deg, transparent 60%, ${h?'#161616':'#111'} 100%)` }} />
        <div style={{ position:"absolute", bottom:8, right:8, background:Y, padding:"4px 8px", borderRadius:20 }}>
          <span style={{ fontSize:14, fontWeight:800, color:"#0A0A0A" }}>{v.price}</span>
          {v.per && <span style={{ fontSize:8, fontWeight:600, color:"#0A0A0A", opacity:0.8 }}>{v.per}</span>}
        </div>
        {bc && (
          <div style={{ position:"absolute", top:8, left:8, background:bc.bg, borderRadius:20, padding:"2px 8px" }}>
            <span style={{ fontSize:9, fontWeight:700, color:bc.color }}>{bc.label}</span>
          </div>
        )}
      </div>
      <div style={{ padding:"12px" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:6 }}>
          <span style={{ fontSize:15, fontWeight:700, color:h?Y:"#fff" }}>{v.name}</span>
          <span style={{ fontSize:11, color:"#666", background:"#1a1a1a", padding:"2px 6px", borderRadius:4 }}>{v.type}</span>
        </div>
        <div style={{ fontSize:10, color:"#777", marginBottom:10 }}>{v.models}</div>
        <div style={{ display:"flex", gap:12, marginBottom:12 }}>
          <div style={{ display:"flex", alignItems:"center", gap:4 }}><span>👤</span><span style={{ fontSize:11, color:"#888" }}>{v.seaters}</span></div>
          <div style={{ display:"flex", alignItems:"center", gap:4 }}><span>👜</span><span style={{ fontSize:11, color:"#888" }}>{v.bags}</span></div>
          <div style={{ display:"flex", alignItems:"center", gap:4 }}><span>❄️</span><span style={{ fontSize:11, color:"#888" }}>AC</span></div>
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:4, marginBottom:12 }}>
          {v.features.slice(0,2).map((f,fi)=>(
            <div key={fi} style={{ display:"flex", alignItems:"center", gap:6 }}>
              <span style={{ width:4, height:4, borderRadius:"50%", background:Y }} />
              <span style={{ fontSize:10, color:"#777" }}>{f}</span>
            </div>
          ))}
        </div>
        <button onClick={()=>onBook(v)} style={{ width:"100%", background:h?Y:"transparent", border:`2px solid ${h?Y:"#333"}`, color:h?"#0A0A0A":"#fff", padding:"8px", borderRadius:8, fontSize:12, fontWeight:700, cursor:"pointer", transition:"all .2s" }}>
          Book Now →
        </button>
      </div>
    </div>
  );
}

function TripCard({ trip, selected, onClick }) {
  const [h,setH]=useState(false);
  const on=selected===trip.id;
  const Icon = trip.icon;
  return (
    <button onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)} onClick={onClick}
      style={{ background:on?"rgba(255,214,0,.95)":h?"rgba(255,255,255,.1)":"rgba(17,17,17,0.8)", border:`2px solid ${on?Y:h?"rgba(255,214,0,.5)":"rgba(255,255,255,.1)"}`, borderRadius:12, padding:"14px 10px", cursor:"pointer", transition:"all .2s", transform:on||h?"translateY(-2px)":"translateY(0)", boxShadow:on?`0 8px 20px rgba(255,214,0,.3)`:"0 4px 12px rgba(0,0,0,.3)", width:"100%", fontFamily:fontD }}>
      <div style={{ display:"flex", flexDirection:"column", alignItems:"center", textAlign:"center", gap:6 }}>
        <div style={{ width:44,height:44,borderRadius:10,background:on?trip.color:"rgba(255,255,255,.1)",display:"flex",alignItems:"center",justifyContent:"center" }}>
          <Icon size={22} color="#fff" />
        </div>
        <div>
          <div style={{ fontSize:14,fontWeight:700,color:on?"#0A0A0A":"#fff",marginBottom:2 }}>{trip.label}</div>
          <span style={{ fontSize:9,fontWeight:600,color:"#fff",background:"rgba(229,24,46,.3)",padding:"2px 6px",borderRadius:20 }}>{trip.sub}</span>
        </div>
        <div style={{ display:"flex",gap:6,marginTop:2 }}>
          {trip.stats.map(s=>(
            <span key={s} style={{ fontSize:8,fontWeight:600,color:on?"#0A0A0A":"#ccc",background:on?"rgba(0,0,0,.1)":"rgba(255,255,255,.1)",padding:"2px 6px",borderRadius:12 }}>{s}</span>
          ))}
        </div>
        {on && <div style={{ width:20,height:20,borderRadius:"50%",background:"#0A0A0A",display:"flex",alignItems:"center",justifyContent:"center",marginTop:4 }}><span style={{ fontSize:12,color:Y,fontWeight:900 }}>✓</span></div>}
      </div>
    </button>
  );
}

/* ─── MAIN ─── */
export default function HeroSection() {
  const [sel, setSel] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const active = TRIPS.find(t => t.id === sel);

  const [isBookingPopupOpen, setIsBookingPopupOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const carImages = [taxiImage, taxiImage, taxiImage];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % carImages.length);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingLoading, setBookingLoading] = useState(false);
  
  const navigate = useNavigate();

 const handleBookNow = (vehicle, tripType, selectedPackage, packageDetails) => {
  console.log('Booking vehicle:', vehicle);
  console.log('Trip type:', tripType);
  
  // Prepare vehicle data for navigation
  const vehicleData = {
    id: vehicle.id,
    name: vehicle.name,
    type: vehicle.type,
    price: vehicle.price,
    pricePerKm: vehicle.pricePerKm || vehicle.price,
    seats: vehicle.seaters || vehicle.capacity || 4,
    bags: vehicle.bags || 3,
    image: getVehicleImage(vehicle),
    features: vehicle.features || [],
    models: vehicle.models || vehicle.name,
    driverBata: vehicle.driverBata,
    nightHalt: vehicle.nightHalt,
    minKm: vehicle.minKm,
    pickupPoint: vehicle.pickupPoint,
    dropoffPoint: vehicle.dropoffPoint,
    // Include package details for local trips
    ...(selectedPackage && { selectedPackage }),
    ...(packageDetails && { packageDetails })
  };

  // Navigate to the booking page
  navigate('/booking', { 
    state: { 
      vehicle: vehicleData,
      tripType: tripType === 'airport' ? 'Airport Taxi' :
                tripType === 'outstation' ? 'Outstation' : 'Local Taxi'
    } 
  });
};
  const handlePopupClose = () => {
    setIsBookingPopupOpen(false);
  };

  const handleBookingSuccess = (response) => {
    console.log('Booking successful:', response);
    setShowBookingForm(false);
    setSelectedVehicle(null);
    alert(`✅ Booking confirmed! Booking ID: ${response.bookingId || response.id || 'N/A'}`);
  };

  const handleBookingError = (error) => {
    console.error('Booking error:', error);
    alert(`❌ Booking failed: ${error}`);
  };

  const handleCloseForm = () => {
    setShowBookingForm(false);
    setSelectedVehicle(null);
  };

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Barlow:wght@400;600;700;800&display=swap');
    *{box-sizing:border-box;}
    ::-webkit-scrollbar{display:none;}
    @keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
    @keyframes slowZoom{0%{transform:scale(1)}50%{transform:scale(1.05)}100%{transform:scale(1)}}
    @keyframes cardIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
    @keyframes floatY{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
    @keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
    @keyframes slideUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
    @keyframes popIn{0%{transform:scale(0.8);opacity:0}100%{transform:scale(1);opacity:1}}
    @keyframes waveMove{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
    @keyframes moveLeftRight {0%{transform:translateX(-10px)}50%{transform:translateX(10px)}100%{transform:translateX(-10px)}}
  `;

  const colors = {
  primary: '#0066FF', // Your primary color
  secondary: '#6B7280',
  textSecondary: '#F3F4F6',
  textLight: '#FFFFFF',
  light: '#FFFFFF',
  background: '#F3F4F6'
};
  /* ── MOBILE ── */
  if (isMobile) {
    return (
      <div style={{ minHeight:"100vh", background:"#F5F5F5", fontFamily:font, overflowX:"hidden" }}>
        <style>{css}</style>

        {/* Header */}
        <div style={{
          background: ` url(${backgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundBlendMode: 'overlay',
          borderRadius:"0 0 32px 32px",
          padding:"48px 20px 36px",
          position:"relative",
          overflow:"hidden",
          boxShadow:"0 8px 32px rgba(255,140,0,0.3)",
        }}>
          <div style={{
            position:"absolute", top:-40, right:-40,
            width:180, height:180, borderRadius:"50%",
            background:"rgba(255,255,255,0.12)",
          }} />
          <div style={{
            position:"absolute", top:20, right:20,
            width:80, height:80, borderRadius:"50%",
            background:"rgba(255,255,255,0.1)",
          }} />
          <div style={{
            position:"absolute", bottom:-20, left:-20,
            width:120, height:120, borderRadius:"50%",
            background:"rgba(0,0,0,0.05)",
          }} />

          <div style={{ position:"relative", zIndex:2, animation:"slideUp 0.5s ease both" }}>
            <div style={{
              display:"inline-flex", alignItems:"center", gap:5,
              background:Y, padding:"4px 12px", borderRadius:20,
              marginBottom:10,
            }}>
              <div style={{ width:6, height:6, borderRadius:"50%", background:Y }} />
              <span style={{ fontSize:9, fontWeight:900, color:"black", letterSpacing:2, textTransform:"uppercase" }}>
                Trusted by 10+ riders
              </span>
            </div>
            <h1 style={{
              fontSize:30, fontWeight:900, color:"#1A1A1A",
              margin:"0 0 8px", lineHeight:1.15, letterSpacing:-0.8,
            }}>
              Chennai Best
              <span style={{ color:"#fff", textShadow:"0 2px 12px rgba(0,0,0,0.15)",gap:"2px" }}>Cab Service</span>
            </h1>

            <div style={{ textAlign: 'center', marginBottom: 40 }}>
  <div style={{ fontSize: 14, color: colors.textSecondary, marginBottom: 8 }}>
    Zero Broker Commission • Direct Guest to Car Owner Connection
  </div>
  <p style={{ fontSize: 12, color: colors.textLight }}>
    No middlemen, no hidden fees. Connect directly with cab owners.
  </p>
</div>
            <p style={{ fontSize:13, color:"rgba(0,0,0,0.55)", margin:0, fontWeight:700 }}>
              Airport · Outstation · Local
            </p>
          </div>

          <div style={{
            display:"flex", gap:8, marginTop:20, position:"relative", zIndex:2,
            animation:"slideUp 0.5s 0.1s ease both",
          }}>
            {[
              { val:"100+", label:"Rides" },
              { val:"4.4★", label:"Rating" },
              { val:"24/7", label:"Support" },
            ].map(s => (
              <div key={s.label} style={{
                flex:1, background:G,
                borderRadius:16, padding:"10px 6px",
                textAlign:"center",
                backdropFilter:"blur(8px)",
                border:"1.5px solid rgba(255,255,255,0.5)",
              }}>
                <div style={{ fontSize:16, fontWeight:900, color:"white", lineHeight:1 }}>{s.val}</div>
                <div style={{ fontSize:9, color:"white", fontWeight:800, marginTop:2 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Trip Type Selector */}
        <div style={{ padding:"20px 16px 0", animation:"slideUp 0.5s 0.2s ease both" }}>
          <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:12 }}>
            <div style={{
              width:22, height:22, borderRadius:8, background:Y,
              display:"flex", alignItems:"center", justifyContent:"center",
              fontSize:12, fontWeight:900, color:"#1A1A1A",
            }}>1</div>
            <span style={{ fontSize:12, fontWeight:900, color:"#555", letterSpacing:0.5 }}>
              Choose trip type
            </span>
          </div>
          <div style={{
            display:"flex", gap:8, background:"#EFEFEF",
            borderRadius:24, padding:"6px",
            boxShadow:"inset 0 2px 6px rgba(0,0,0,0.05)",
          }}>
            {TRIPS.map(trip => (
              <MobileTripTab
                key={trip.id} trip={trip} selected={sel}
                onClick={() => setSel(sel === trip.id ? null : trip.id)}
              />
            ))}
          </div>

          {sel && (
            <div style={{
              marginTop:10, background:YL,
              border:`1.5px solid #FFE082`, borderRadius:14,
              padding:"9px 14px",
              display:"flex", alignItems:"center", gap:8,
              animation:"popIn 0.3s ease both",
            }}>
              <span style={{ fontSize:18 }}>{active?.emoji}</span>
              <div>
                <span style={{ fontSize:12, fontWeight:900, color:"#1A1A1A" }}>{active?.label}</span>
                <span style={{ fontSize:10, color:YD, fontWeight:700, marginLeft:6 }}>· {active?.desc}</span>
              </div>
            </div>
          )}
        </div>

        {/* Vehicles */}
        <div style={{ padding:"20px 16px 60px" }}>
          {!sel ? (
            <div style={{ animation:"fadeIn 0.4s ease" }}>
              <div style={{
                background:"#fff", borderRadius:24, padding:"32px 20px",
                textAlign:"center",
                boxShadow:"0 4px 20px rgba(0,0,0,0.05)",
                border:"2px dashed #28aa96",
              }}>
                <div style={{ 
                  display: "flex", justifyContent: "center", alignItems: "center", width: "100%", marginBottom: 16
                }}>
                  <div style={{ width: 180, height: 100, animation: "moveLeftRight 5s ease-in-out infinite" }}>
                    <img src={carImages[currentImage]} alt="Taxi" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                  </div>
                </div>
                <p style={{ fontSize:18, fontWeight:900, color:"#1A1A1A", margin:"0 0 8px" }}>Ready to Ride?</p>
                <p style={{ fontSize:13, color:"#BBB", fontWeight:700, margin:"0 0 20px" }}>
                  Pick a trip type above to see available vehicles
                </p>
                <div style={{ display:"flex", gap:8, justifyContent:"center" }}>
                  {TRIPS.map(t => (
                    <button key={t.id} onClick={() => setSel(t.id)} style={{
                      background:G, border:"none", borderRadius:14,
                      padding:"8px 14px", cursor:"pointer",
                      fontSize:11, fontWeight:900, color:"#1A1A1A",
                      display:"flex", alignItems:"center", gap:4,color:"white"
                    }}>
                      <span>{t.emoji}</span> {t.label}
                    </button>
                  ))}
                </div>
              </div>

              <div style={{ display:"flex", gap:10, marginTop:16 }}>
                {[
                  { icon:<Shield size={16} color={YD} />, text:"Safe Rides", sub:"Verified drivers" },
                  { icon:<Clock size={16} color={YD} />, text:"On Time", sub:"GPS tracked" },
                ].map((item,i) => (
                  <div key={i} style={{
                    flex:1, background:"#fff", borderRadius:18, padding:"14px 12px",
                    display:"flex", alignItems:"center", gap:10,
                    boxShadow:"0 2px 10px rgba(0,0,0,0.05)",
                    border:"1.5px solid #F0F0F0",
                  }}>
                    <div style={{
                      width:38, height:38, borderRadius:12, background:YL,
                      display:"flex", alignItems:"center", justifyContent:"center",
                      flexShrink:0, border:"1.5px solid #FFE082",
                    }}>{item.icon}</div>
                    <div>
                      <div style={{ fontSize:13, fontWeight:900, color:"#1A1A1A" }}>{item.text}</div>
                      <div style={{ fontSize:10, color:"#BBB", fontWeight:700 }}>{item.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ animation:"fadeIn 0.3s ease" }}>
              <div style={{
                display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16,
              }}>
                <div>
                  <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:2 }}>
                    <div style={{
                      width:22, height:22, borderRadius:8, background:Y,
                      display:"flex", alignItems:"center", justifyContent:"center",
                      fontSize:12, fontWeight:900, color:"#1A1A1A",
                    }}>2</div>
                    <span style={{ fontSize:12, fontWeight:900, color:"#555", letterSpacing:0.5 }}>
                      Select vehicle
                    </span>
                  </div>
                  <span style={{ fontSize:18, fontWeight:900, color:"#1A1A1A" }}>
                    {VEHICLES[sel].length} Available
                  </span>
                </div>
                <button onClick={() => setSel(null)} style={{
                  background:"#fff", border:`1.5px solid #E8E8E8`,
                  color:"#555", padding:"8px 16px", borderRadius:30,
                  fontSize:11, fontWeight:800, cursor:"pointer",
                  boxShadow:"0 2px 8px rgba(0,0,0,0.06)",
                  display:"flex", alignItems:"center", gap:4,
                }}>
                  ← Back
                </button>
              </div>

              {VEHICLES[sel].map((v, i) => (
                <MobileVCard
                  key={v.id} 
                  v={v} 
                  index={i}
                  tripType={sel}
                  onBook={handleBookNow}
                />
              ))}

              {showBookingForm && selectedVehicle && (
                <div 
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0, 0, 0, 0.7)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                    backdropFilter: "blur(8px)",
                    animation: "fadeIn 0.3s ease"
                  }}
                  onClick={handleCloseForm}
                >
                  <div 
                    style={{
                      maxWidth: "700px",
                      width: "100%",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      borderRadius: "28px",
                      background: "#fff",
                      boxShadow: "0 30px 60px rgba(0,0,0,0.3)",
                      animation: "slideUp 0.4s ease"
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* {sel === 'airport' && (
                      <AirportBookingForm 
                        selectedVehicle={selectedVehicle}
                        onClose={handleCloseForm}
                        onSuccess={handleBookingSuccess}
                        onError={handleBookingError}
                      />
                    )}
                    {sel === 'outstation' && (
                      <OutstationBookingForm 
                        selectedVehicle={selectedVehicle}
                        onClose={handleCloseForm}
                        onSuccess={handleBookingSuccess}
                        onError={handleBookingError}
                      />
                    )}
                    {sel === 'local' && (
                      <LocalBookingForm 
                        selectedVehicle={selectedVehicle}
                        onClose={handleCloseForm}
                        onSuccess={handleBookingSuccess}
                        onError={handleBookingError}
                      />
                    )} */}
                  </div>
                </div>
              )}

              <div style={{
                background:`linear-gradient(135deg, #FFD600 0%, #FFAA00 100%)`,
                borderRadius:24, padding:"18px 20px", marginTop:6,
                boxShadow:"0 8px 28px rgba(255,214,0,0.4)",
                position:"relative", overflow:"hidden",
              }}>
                <div style={{
                  position:"absolute", top:-20, right:-20,
                  width:100, height:100, borderRadius:"50%",
                  background:"rgba(255,255,255,0.15)",
                }} />
                <p style={{ fontSize:9, fontWeight:900, color:"rgba(0,0,0,0.4)", margin:"0 0 14px", letterSpacing:"2px", textTransform:"uppercase" }}>
                  Why Choose Plus Cabs?
                </p>
                <div style={{ display:"flex", justifyContent:"space-around" }}>
                  {[
                    { icon:"✅", text:"Best Price" },
                    { icon:"🔒", text:"Safe Rides" },
                    { icon:"📞", text:"24/7 Help" },
                    { icon:"❌", text:"Free Cancel" },
                  ].map(item => (
                    <div key={item.text} style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:6 }}>
                      <div style={{
                        width:40, height:40, borderRadius:14,
                        background:"rgba(255,255,255,0.4)",
                        display:"flex", alignItems:"center", justifyContent:"center",
                        fontSize:18,
                        border:"1.5px solid rgba(255,255,255,0.5)",
                      }}>{item.icon}</div>
                      <span style={{ fontSize:9, fontWeight:900, color:"#1A1A1A" }}>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* <BookingFormPopup 
          isOpen={isBookingPopupOpen}
          onClose={handlePopupClose}
        /> */}
      </div>
    );
  }

  /* ── DESKTOP ── */
  return (
    <section style={{ minHeight:"100vh", position:"relative", overflow:"hidden", fontFamily:fontD }}>
      <style>{css}</style>
      
      <div style={{ position:"absolute", inset:0, overflow:"hidden" }}>
        <div style={{
          display:"flex",
          width:"300%",
          height:"100%",
          animation:"slideBackground 24s ease infinite",
          transform:"translateX(0)"
        }}>
          <div style={{ width:"33.333%", height:"100%", backgroundImage:`url(${hero1})`, backgroundSize:"cover", backgroundPosition:"center", backgroundRepeat:"no-repeat" }} />
          <div style={{ width:"33.333%", height:"100%", backgroundImage:`url(${hero2})`, backgroundSize:"cover", backgroundPosition:"center", backgroundRepeat:"no-repeat" }} />
          <div style={{ width:"33.333%", height:"100%", backgroundImage:`url(${hero1})`, backgroundSize:"cover", backgroundPosition:"center", backgroundRepeat:"no-repeat" }} />
        </div>
        
        <div style={{
          position:"absolute",
          inset:0,
          background:"linear-gradient(135deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.2) 100%)",
          pointerEvents:"none"
        }} />
      </div>

      <style>{`
        ${css}
        @keyframes slideBackground {
          0%, 25% { transform: translateX(0); }
          33.33%, 58.33% { transform: translateX(-33.333%); }
          66.66%, 91.66% { transform: translateX(-66.666%); }
          100% { transform: translateX(0); }
        }
      `}</style>

      <div style={{ maxWidth:1200, margin:"0 auto", padding:"40px 16px 60px", position:"relative", zIndex:2 }}>
        <div style={{ marginBottom:32, textAlign:"center" }}>
          <div style={{ display:"inline-flex", alignItems:"center", gap:6, background:"rgba(229,24,46,.2)", border:"1px solid rgba(229,24,46,.3)", borderRadius:99, padding:"6px 18px", marginBottom:12, backdropFilter:"blur(10px)" }}>
            <span style={{ width:6, height:6, borderRadius:"50%", background:"#E5182E", display:"inline-block" }}/>
            <span style={{ fontSize:12, fontWeight:700, color:"#fff", letterSpacing:"1px" }}>🚕 PREMIER CAB SERVICES</span>
          </div>
          <h1 style={{ fontSize:"clamp(32px,5vw,48px)", fontWeight:800, color:"#fff", margin:"0 0 12px", lineHeight:1.3, textShadow:"0 4px 20px rgba(0,0,0,.5)" }}>
            <span style={{ color:G }}>Chennai Most Trusted</span> Cab Service
          </h1>
          <p style={{ fontSize:16, color:"#e0e0e0", maxWidth:700, margin:"0 auto 12px", lineHeight:1.5 }}>
            Book affordable cabs for airport, local & outstation trips. 24/7 availability.
          </p>
        </div>
        <div style={{ marginBottom:24 }}>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12 }}>
            {TRIPS.map(trip=>(
              <TripCard key={trip.id} trip={trip} selected={sel} onClick={()=>setSel(sel===trip.id?null:trip.id)}/>
            ))}
          </div>
        </div>
        {sel && (
          <div style={{ animation:"fadeIn .4s ease" }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16, background:"rgba(0,0,0,.5)", padding:"12px 16px", borderRadius:10, backdropFilter:"blur(10px)" }}>
              <span style={{ fontSize:16, fontWeight:700, color:Y }}>{active?.label}</span>
              <button onClick={()=>setSel(null)} style={{ background:"rgba(255,255,255,.1)", border:"1px solid rgba(255,255,255,.2)", color:"#fff", padding:"6px 16px", borderRadius:30, fontSize:11, fontWeight:600, cursor:"pointer" }}>← Change</button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(280px, 1fr))", gap:16 }}>
              {VEHICLES[sel].map((v, i) => (
                <MobileVCard
                  key={v.id} 
                  v={v} 
                  index={i}
                  tripType={sel}
                  onBook={handleBookNow}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      {/* <BookingFormPopup 
        isOpen={isBookingPopupOpen}
        onClose={handlePopupClose}
      /> */}
    </section>
  );
}
